import { ConfigClientModule } from '../models/ConfigClientModule'
import { UpdateConfigClientModule } from '../models/UpdateConfigClientModule'
import { ConfigClientModuleRepository } from '../repositories/ConfigClientModuleRepository'

export function ConfigSleepModuleCase(
  configClientRepository: ConfigClientModuleRepository
) {
  return {
    async sleepConfig(patientId: string): Promise<ConfigClientModule> {
      return await configClientRepository.sleepConfig(patientId)
    },
    async updateSleepConfig(
      config: UpdateConfigClientModule
    ): Promise<ConfigClientModule> {
      return await configClientRepository.updateSleepConfig(config)
    }
  }
}
